async function devtricker_fetch_user_profile() {
    try {
        const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);
        url.searchParams.append('action', 'devtricker_profile_fetch');

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        });

        const result = await response.json();

        if (result.error) {
            console.error('Error fetching profile:', result.error);
            return null;
        }

        console.log('Profile data:', result);
        return result;
    } catch (error) {
        console.error('Failed to fetch profile:', error);
        return null;
    }
}

async function devtricker_updateUserProfile(userId) {
    const name = document.getElementById('profileName').value;
    const username = document.getElementById('profileArroba').value;
    const bio = document.getElementById('profileBio').value;
    const website = document.getElementById('profileWebsite').value;
    const linkedin = document.getElementById('profileLinkedin').value;
    const github = document.getElementById('profileGitHub').value;

    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('action', 'devtricker_profile_upsert');
    formData.append('user_id', userId);
    formData.append('name', name);
    formData.append('username', username);
    formData.append('bio', bio);
    formData.append('website', website);
    formData.append('linkedin', linkedin);
    formData.append('github', github);

    const uploadUrl = '/wp-admin/admin-ajax.php';

    try {
        const response = await fetch(uploadUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const result = await response.json();

        if (result.success) {
            console.log('Profile update successful:', JSON.stringify(result));
            return result.data;
        } else {
            console.error('Error from server:', result.data);
            throw new Error(result.data.message || 'Error updating the profile');
        }
    } catch (error) {
        console.error('Failed to update profile:', error);
        throw error;
    }
}

async function devtricker_fetch_user_email() {
    try {
        const url = new URL('/wp-admin/admin-ajax.php', window.location.origin);
        url.searchParams.append('action', 'devtricker_email_fetch_ajax');

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.success) {
            return result.data.email;
        } else {
            console.error('Error fetching email:', result.data ? result.data.message : 'Unknown error');
            return null;
        }
    } catch (error) {
        console.error('Failed to fetch email:', error);
        return null;
    }
}

async function devtricker_updateUserEmail(email, password) {
    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('action', 'devtricker_update_user_email_ajax');
    formData.append('user_id', devtricker_getTheLoggedUserId());
    formData.append('password', password);
    formData.append('email', email);

    const uploadUrl = '/wp-admin/admin-ajax.php';

    try {
        const response = await fetch(uploadUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const result = await response.json();

        if (result.success) {
            console.log('Email update successful:', JSON.stringify(result));
            return result.data;
        } else {
            console.error('Error from server:', result.data);
            throw new Error(result.data.message || 'Error updating the email');
        }
    } catch (error) {
        console.error('Failed to update email:', error);
        throw error;
    }
}

async function devtricker_updatePassword(currentPassword, newPassword, passwordStrength) {
    try {
        const formData = new FormData();
        formData.append('action', 'devtricker_update_password_ajax');
        formData.append('current_password', currentPassword);
        formData.append('new_password', newPassword);
        formData.append('password_strength', passwordStrength);
        formData.append('nonce', await devtricker_process_getDevtrickerNonce());

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        if (result.success) {
            console.log("Password successfully updated");
            return result;
        } else {
            throw new Error(result.data.message);
        }
    } catch (error) {
        console.error("Failed to update password:", error);
        throw error;
    }
}

async function devtricker_uploadUserProfileImage(file) {
    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('image', file);
    formData.append('action', 'devtricker_update_user_profile_image');

    const response = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Network error while trying to upload the image.');
    }

    const result = await response.json();

    if (result.success) {
        return result.data.image_url;
    } else {
        throw new Error(result.data.message || 'Error updating the profile picture');
    }
}

async function devtricker_removeUserProfileImage(file) {
    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('action', 'devtricker_remove_user_profile_image');

    const response = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Network error while trying to delete the image.');
    }

    const result = await response.json();

    if (result.success) {
        return result.data.image_url;
    } else {
        throw new Error(result.data.message || 'Error deleting the profile picture.');
    }
}